export default __webpack_public_path__ + "static/media/2 Foundational Core  Pelvic Floor Videos.540482cb.png";